import {styled} from '../../styled-components';

export interface DialogStyleProps {
    /**
     * When `true`, dialog will stretch to `maxWidth`
     */
    fullwidth?: string | boolean;
}

export const DialogStyle = styled.div<DialogStyleProps>`
    display: flex;
    flex-direction: column;
    flex: 0 1 auto;
    overflow-y: auto;
    max-width: 80vw;
    max-height: ${props => `calc(100% - ${props.theme.spacing.units(4)})`};
    margin: ${props => props.theme.spacing.units(4)} auto;
    pointer-events: auto;
    font-family: ${props => props.theme.typography.fontFamily};
    width: ${props => (props.fullwidth ? '100%' : props.theme.spacing.units(60))};
    border-radius: 4px;

    @media only screen and (min-width: 1200px) {
        max-width: 43vw;
    }
`;

DialogStyle.displayName = 'DialogStyle';
